import { mockBasketOffer } from '@domgen/dgx-fe-basket';
import { CheckoutCompletedOffer } from '../../models/checkout-completed-item/checkout-completed-offer.interface';
import { CheckoutResponse } from '../../models/checkout/checkout-response.interface';
import { mockCheckoutCompletedOffer } from '../checkout-completed-item/checkout-completed-offer.mock';

export const mockCheckoutResponseOffer: CheckoutResponse<CheckoutCompletedOffer> =
  {
    completedItems: [mockCheckoutCompletedOffer],
    basket: mockBasketOffer,
  };
